import { useState, useEffect, createElement } from "react";
import PropTypes from "prop-types";
const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
};
const defaultProps = {
  defaultValue: void 0,
  onChange: void 0
};
function uncontrolled(Component, options = {}) {
  const { valueProp = "value" } = options;
  const UncontrolledComponent = ({ defaultValue, onChange, ...restProps }) => {
    const [state, setState] = useState(defaultValue);
    const stateProps = {
      [valueProp]: state,
      onChange: setState
    };
    useEffect(() => {
      if (onChange) {
        onChange(state);
      }
    }, [state]);
    return createElement(Component, { ...restProps, ...stateProps });
  };
  UncontrolledComponent.propTypes = propTypes;
  UncontrolledComponent.defaultProps = defaultProps;
  return UncontrolledComponent;
}
export {
  uncontrolled
};
